import React, { FunctionComponent } from 'react'

interface Props {
  className?: string
}
export const Spinner: FunctionComponent<Props> = ({ className = '' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='800' width='800' x='0' y='0' viewBox='0 0 800 800'>
    <defs>
      <linearGradient id='Gradient1' gradientTransform='rotate(90)'>
        <stop offset='0%' stopColor='rgba(0, 0, 0, 1)' />
        <stop offset='100%' stopColor='rgba(0, 0, 0, 0.5)' />
      </linearGradient>
      <linearGradient id='Gradient2' gradientTransform='rotate(90)'>
        <stop offset='0%' stopColor='rgba(246, 246, 246, 0)' stopOpacity='0' />
        <stop offset='90%' stopColor='rgba(0, 0, 0, 0.5)' />
        <stop offset='100%' stopColor='rgba(0, 0, 0, 0.65)' />
      </linearGradient>
      <pattern id='Pattern' x='0' y='0' width='600' height='600' patternUnits='userSpaceOnUse'>
        <g transform='rotate(0, 300, 300)'>
          <rect shapeRendering='crispEdges' x='0' y='0' width='300' height='600' fill='url(#Gradient1)' />
          <rect shapeRendering='crispEdges' x='300' y='0' width='300' height='600' fill='url(#Gradient2)' />
        </g>
      </pattern>
    </defs>
    <g transform='translate(100, 100)'>
      <path
        className={className}
        style={{ stroke: 'url(#Pattern)' }}
        fill='transparent'
        transform='rotate(105, 300, 300)'
        strokeWidth='80'
        d='M 364 58 A 250 250 0 1 1 235 58'
      />
    </g>
  </svg>
)
